import type { Season, Intensity, ParticleCustomization } from '../types';
import { ParticleEffect } from './ParticleEffect';
import { WinterEffect } from './WinterEffect';
import { SpringEffect } from './SpringEffect';
import { SummerEffect } from './SummerEffect';
import { AutumnEffect } from './AutumnEffect';
import { EventEffect } from './EventEffect';

export { ParticleEffect, WinterEffect, SpringEffect, SummerEffect, AutumnEffect, EventEffect };

/**
 * Factory function to create the appropriate effect for a season
 */
export function createSeasonEffect(
    season: Season,
    intensity: Intensity,
    variant?: string,
    customization?: ParticleCustomization
): ParticleEffect {
    switch (season) {
        case 'winter':
            return new WinterEffect(intensity, variant, customization);
        case 'spring':
            return new SpringEffect(intensity, variant, customization);
        case 'summer':
            return new SummerEffect(intensity, variant, customization);
        case 'autumn':
            return new AutumnEffect(intensity, variant, customization);
        case 'event':
            return new EventEffect(intensity, variant, customization);
        default:
            return new WinterEffect(intensity, undefined, customization);
    }
}
